import { render, staticRenderFns } from "./RequestNegotiation.vue?vue&type=template&id=475a2acd&scoped=true&"
import script from "./RequestNegotiation.vue?vue&type=script&lang=js&"
export * from "./RequestNegotiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a2acd",
  null
  
)

export default component.exports